import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header id="header" className="site-header header-style-1">
      {/* Topbar */}
      <div className="topbar">
        <div className="container">
          <div className="row">
            <div className="col col-md-10">
              <div className="contact-info">
                <ul className="clearfix">
                  <li><span>Call Us:</span> 548978478</li>
                  <li><span>Email us:</span> demo@example.com</li>
                  <li><span>Our address:</span> Av. Libertad, Santa Victoria, Chiclayo</li>
                </ul>
              </div>
            </div>
            <div className="col col-md-2">
              <div className="social">
                <ul className="clearfix">
                  <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="ti-facebook"></i></a></li>
                  <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="ti-twitter-alt"></i></a></li>
                  <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="ti-linkedin"></i></a></li>
                  <li><a href="https://pinterest.com" target="_blank" rel="noopener noreferrer"><i className="ti-pinterest"></i></a></li>
                  <li><a href="https://skype.com" target="_blank" rel="noopener noreferrer"><i className="ti-skype"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="navigation navbar navbar-default original">
        <div className="container">
          <div className="navbar-header">
            <button type="button" className="open-btn">
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <Link className="navbar-brand" to="/">
              <img src="assets/images/logo.png" alt="Codecom Law Firm" />
            </Link>
          </div>
          
          <div id="navbar" className="navbar-collapse collapse navbar-right navigation-holder">
            <button className="close-navbar"><i className="ti-close"></i></button>
            <ul className="nav navbar-nav">
              <li className="menu-item-has-children">
                <Link to="/">Home</Link>
                <ul className="sub-menu">
                  <li><Link to="/">Home Default</Link></li>
                  <li><Link to="/home-2">Home Style 2</Link></li>
                  <li><Link to="/home-3">Home Single Lawyer</Link></li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="/about">Pages</Link>
                <ul className="sub-menu">
                  <li><Link to="/about">About Company</Link></li>
                  <li><Link to="/about-me">About Me</Link></li>
                  <li><Link to="/testimonials">Testimonials</Link></li>
                  <li><Link to="/testimonials-s2">Testimonials Style 2</Link></li>
                  <li><Link to="/team">Team</Link></li>
                  <li><Link to="/team-single">Team Single</Link></li>
                  <li><Link to="/faq">FAQ</Link></li>
                  <li><Link to="/404">404</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="/shop">Shop</Link>
                <ul className="sub-menu">
                  <li><Link to="/shop">Shop</Link></li>
                  <li><Link to="/shop-single">Shop Single</Link></li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="/services">Services</Link>
                <ul className="sub-menu">
                  <li><Link to="/services">Services</Link></li>
                  <li><Link to="/services-s2">Service Style 2</Link></li>
                  <li><Link to="/service-single">Business Law</Link></li>
                  <li><Link to="/family-law">Family Law</Link></li>
                  <li><Link to="/real-estate-law">Real State Law</Link></li>
                  <li><Link to="/education-law">Education Law</Link></li>
                  <li><Link to="/criminal-law">Criminal Law</Link></li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="/case-studies">Projects</Link>
                <ul className="sub-menu">
                  <li><Link to="/case-studies">Case Studies</Link></li>
                  <li><Link to="/case-studies-s2">Case Studies Style 2</Link></li>
                  <li><Link to="/project-single">Case Studies Single</Link></li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="/blog">Blog</Link>
                <ul className="sub-menu">
                  <li><Link to="/blog">Blog</Link></li>
                  <li><Link to="/blog-left-sidebar">Blog Left sidebar</Link></li>
                  <li><Link to="/blog-fullwidth">Blog full width</Link></li>
                  <li className="menu-item-has-children">
                    <Link to="/blog-single">Blog single</Link>
                    <ul className="sub-menu">
                      <li><Link to="/blog-single">Blog single</Link></li>
                      <li><Link to="/blog-single-left-sidebar">Blog single Left sidebar</Link></li>
                      <li><Link to="/blog-single-fullwidth">Blog single full width</Link></li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="cart-search-contact">
            <div className="header-search-form-wrapper">
              <button className="search-toggle-btn"><i className="fi flaticon-magnifying-glass"></i></button>
              <div className="header-search-form">
                <form>
                  <div>
                    <input type="text" className="form-control" placeholder="Search here..." />
                    <button type="submit"><i className="ti-search"></i></button>
                  </div>
                </form>
              </div>
            </div>
            <div className="mini-cart">
              <button className="cart-toggle-btn"> 
                <i className="fi flaticon-basket"></i> 
                <span className="cart-count">02</span>
              </button>
              <div className="mini-cart-content">
                <div className="mini-cart-items">
                  <div className="mini-cart-item clearfix">
                    <div className="mini-cart-item-image">
                      <Link to="/shop-single">
                        <img src="assets/images/shop/mini-cart/img-1.jpg" alt="Hoodi with zipper" />
                      </Link>
                    </div>
                    <div className="mini-cart-item-des">
                      <Link to="/shop-single">Hoodi with zipper</Link>
                      <span className="mini-cart-item-price">$20.15</span>
                      <span className="mini-cart-item-quantity">x 1</span>
                    </div>
                  </div>
                  <div className="mini-cart-item clearfix">
                    <div className="mini-cart-item-image">
                      <Link to="/shop-single">
                        <img src="assets/images/shop/mini-cart/img-2.jpg" alt="Ninja T-shirt" />
                      </Link>
                    </div>
                    <div className="mini-cart-item-des">
                      <Link to="/shop-single">Ninja T-shirt</Link>
                      <span className="mini-cart-item-price">$13.25</span>
                      <span className="mini-cart-item-quantity">x 2</span>
                    </div>
                  </div>
                </div>
                <div className="mini-cart-action clearfix">
                  <span className="mini-checkout-price">$215.14</span>
                  <Link to="/cart" className="view-cart-btn">View Cart</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Sticky Header - Mismo contenido pero simplificado */}
      <nav className="navigation navbar navbar-default sticky-header">
        <div className="container">
          <div className="navbar-header">
            <button type="button" className="open-btn">
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <Link className="navbar-brand" to="/">
              <img src="assets/images/logo.png" alt="Codecom Law Firm" />
            </Link>
          </div>
          
          <div id="navbar" className="navbar-collapse collapse navbar-right navigation-holder">
            <button className="close-navbar"><i className="ti-close"></i></button>
            <ul className="nav navbar-nav">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/team">Our Team</Link></li>
              <li><Link to="/case-studies">Case Studies</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="cart-search-contact">
            <div className="header-search-form-wrapper">
              <button className="search-toggle-btn"><i className="fi flaticon-magnifying-glass"></i></button>
            </div>
            <div className="mini-cart">
              <button className="cart-toggle-btn"> 
                <i className="fi flaticon-basket"></i> 
                <span className="cart-count">02</span>
              </button>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;